import { render } from "./Videos.vue?vue&type=template&id=f44b37f0"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__